import * as types from "./actionTypes";
import * as api from "../../api";

export const setActiveProductCategory = (category) => {
  return {
    type: types.PRODUCTS_SET_ACTIVE_PRODUCT_CATEGORY_ID,
    payload: { category },
  };
};

export const setSearchQuery = (query) => {
  return { type: types.PRODUCTS_SET_SEARCH_QUERY, payload: { query } };
};

export const searchProductsByQuery = ({
  query,
  navigate,
  pageNum,
  pageSize,
}) => {
  return (dispatch) => {
    api
      .searchProducts({ query, pageNum, pageSize })
      .then((res) => {
        dispatch({
          type: types.PRODUCTS_SEARCH_PRODUCTS,
          payload: { products: res.data.products, query },
        });
        if (navigate !== undefined) {
          navigate({
            pathname: "/search",
            search: `?q=${query}`,
          });
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };
};

export const getProductBySku = ({ sku, navigate, locale }) => {
  return (dispatch) => {
    api
      .getProductBySku({ sku, locale })
      .then((res) => {
        dispatch({
          type: types.PRODUCTS_GET_PRODUCT_BY_SKU,
          payload: { product: res.data },
        });
      })
      .catch((err) => {
        console.log({ err });
        navigate({
          pathname: "/",
        });
      });
  };
};

export const getProductsByCategory = ({ category, pageNum, locale }) => {
  return (dispatch) => {
    api
      .getProductByCategoryWithPageSize({
        category,
        pageNum,
        locale,
      })
      .then((res) => {
        dispatch({
          type: types.PRODUCTS_GET_PRODUCTS_BY_CATEGORY,
          payload: { products: res.data.products },
        });
      })
      .catch((err) => {
        console.log({ err });
      });
  };
};

export const resetProductsByCateogory = () => {
  return { type: types.PRODUCTS_RESET_PRODUCTS_BY_CATEGORY };
};
